/**
 * Reasons for demoting a contract back to recruiter (Asignar a Recruiter).
 * Values are sent in the request; labels are resolved via i18n.
 */
export const CONTRACT_DEMOTE_REASON = {
  CLIENT_REJECTS_PROFILE: "client_rejects_profile",
  CLIENT_REQUESTS_2ND_PROFILE: "client_requests_2nd_profile",
  CLIENT_REQUESTS_NEW_PROFILE_CONDITIONS_CHANGE:
    "client_requests_new_profile_conditions_change",
  ADVISOR_REJECTS_PROFILE: "advisor_rejects_profile",
  CAREGIVER_SELF_WITHDRAWS: "caregiver_self_withdraws",
} as const;

export type ContractDemoteReason =
  (typeof CONTRACT_DEMOTE_REASON)[keyof typeof CONTRACT_DEMOTE_REASON];

export const CONTRACT_DEMOTE_REASONS: ContractDemoteReason[] = [
  CONTRACT_DEMOTE_REASON.CLIENT_REJECTS_PROFILE,
  CONTRACT_DEMOTE_REASON.CLIENT_REQUESTS_2ND_PROFILE,
  CONTRACT_DEMOTE_REASON.CLIENT_REQUESTS_NEW_PROFILE_CONDITIONS_CHANGE,
  CONTRACT_DEMOTE_REASON.ADVISOR_REJECTS_PROFILE,
  CONTRACT_DEMOTE_REASON.CAREGIVER_SELF_WITHDRAWS,
];
